import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/iconfont/iconfont.css'

import {
  Swipe,
  SwipeItem,
  Icon,
  Grid,
  GridItem,
  NoticeBar,
  Tab,
  Tabs,
  Pagination,
  NavBar
} from 'vant'

import axios from 'axios'
axios.defaults.baseURL = 'https://api.xingy1.top/api'
Vue.prototype.$http = axios

const DEFAULT_SITE_TITLE = '搴旂敤瀵艰埅缃戠珯'
const SITE_TITLE_CACHE_KEY = 'app_site_title'
let siteTitle = DEFAULT_SITE_TITLE

try {
  const cachedTitle = String(localStorage.getItem(SITE_TITLE_CACHE_KEY) || '').trim()
  if (cachedTitle) {
    siteTitle = cachedTitle
  }
} catch (error) {
  siteTitle = DEFAULT_SITE_TITLE
}

const ATTR_KEYS = {
  deviceId: 'app_client_device_id',
  installAt: 'app_first_install_at',
  installReported: 'app_install_reported',
  retainPrefix: 'app_retain_reported_'
}

const getDeviceId = () => {
  let value = localStorage.getItem(ATTR_KEYS.deviceId)
  if (!value) {
    value = `dv_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
    localStorage.setItem(ATTR_KEYS.deviceId, value)
  }
  return value
}

const getPlatform = () => {
  const ua = String(navigator.userAgent || '').toLowerCase()
  if (/android/.test(ua)) return 'android'
  if (/iphone|ipad|ipod|ios/.test(ua)) return 'ios'
  return 'other'
}

const getChannelCode = () => {
  const byGlobal = String(window.__APP_CHANNEL_CODE__ || '').trim()
  if (byGlobal) return byGlobal
  const query = new URLSearchParams(window.location.search || '')
  const byQuery = String(query.get('ch') || query.get('channel_code') || '').trim()
  if (byQuery) return byQuery
  return ''
}

const postAppEvent = (eventType, ext = {}) => {
  return axios.post('/app_data_report', {
    device_id: getDeviceId(),
    platform: getPlatform(),
    event_type: eventType,
    ...ext
  }).catch(() => {
    // 涓婃姤澶辫触涓嶉樆鏂富娴佺▼
  })
}

const maybeReportInstallAndRetain = async (channelCode) => {
  if (!channelCode) return

  const now = Date.now()
  let installAt = Number(localStorage.getItem(ATTR_KEYS.installAt) || 0)
  if (!installAt) {
    installAt = now
    localStorage.setItem(ATTR_KEYS.installAt, String(installAt))
  }

  const installReportedKey = `${ATTR_KEYS.installReported}_${channelCode}`
  if (localStorage.getItem(installReportedKey) !== '1') {
    await postAppEvent('install', { channel_code: channelCode })
    localStorage.setItem(installReportedKey, '1')
  }

  const dayMs = 24 * 60 * 60 * 1000
  const installDay = Math.floor(installAt / dayMs)
  const today = Math.floor(now / dayMs)
  const diffDays = Math.max(0, today - installDay)
  const retainDays = [1, 7, 30]

  for (const d of retainDays) {
    const key = `${ATTR_KEYS.retainPrefix}${d}_${channelCode}`
    if (diffDays >= d && localStorage.getItem(key) !== '1') {
      await postAppEvent('retain', { channel_code: channelCode, retain_day: d })
      localStorage.setItem(key, '1')
    }
  }
}

const initChannelAttribution = async () => {
  const channelCode = getChannelCode()
  if (!channelCode) return

  await maybeReportInstallAndRetain(channelCode)
  await postAppEvent('open', { channel_code: channelCode, open_count: 1 })

  setInterval(() => {
    postAppEvent('online', { channel_code: channelCode, online_seconds: 30 })
  }, 30000)
}

const applyDocumentTitle = () => {
  document.title = siteTitle || DEFAULT_SITE_TITLE
}

const loadSiteTitle = async () => {
  try {
    const { data: res } = await axios.get('/set')
    const title = String((((res || {}).data || [])[0] || {}).title || '').trim()
    if (title) {
      siteTitle = title
      try {
        localStorage.setItem(SITE_TITLE_CACHE_KEY, title)
      } catch (error) {
        // localStorage 涓嶅彲鐢ㄦ椂蹇界暐
      }
    }
  } catch (error) {
    siteTitle = DEFAULT_SITE_TITLE
  }

  applyDocumentTitle()
}

Vue.config.productionTip = false

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(NoticeBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(NavBar)

initChannelAttribution()
loadSiteTitle()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.afterEach(() => {
  applyDocumentTitle()
})
